import { render, staticRenderFns } from "./ModalCofirm.vue?vue&type=template&id=374dbd0e&"
import script from "./ModalCofirm.vue?vue&type=script&lang=js&"
export * from "./ModalCofirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports